module.exports = __webpack_public_path__ + "img/header-engagementRingsRingsets@2x.dca057d.jpg";